var _path, _path2;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlayButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "play-button",
    xmlns: "http://www.w3.org/2000/svg",
    width: 108.524,
    height: 108.509,
    viewBox: "0 0 108.524 108.509",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_140042",
    "data-name": "Path 140042",
    d: "M39.4,26.659,16.863,10.278a2.717,2.717,0,0,0-4.316,2.192V45.221a2.709,2.709,0,0,0,1.484,2.423,2.737,2.737,0,0,0,1.235.293,2.7,2.7,0,0,0,1.6-.527L39.4,31.043a2.7,2.7,0,0,0,0-4.384Z",
    transform: "translate(32.764 25.474)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_140043",
    "data-name": "Path 140043",
    d: "M54.264,0a54.255,54.255,0,1,0,54.26,54.264A54.257,54.257,0,0,0,54.264,0Zm0,99.456A45.2,45.2,0,1,1,99.456,54.266,45.193,45.193,0,0,1,54.264,99.458Z",
    transform: "translate(0 -0.002)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayButton);
export default __webpack_public_path__ + "static/media/play-button.74dd0b22eedfdc879ae99e961eeddb0a.svg";
export { ForwardRef as ReactComponent };